module.exports = __webpack_public_path__ + "static/media/SCBsettings.eede1c7e.svg";